import React, { useState, useEffect, useContext } from 'react';
import { CompanyContext } from '../../../global_setting/Store';
import config from '../../../../src/config.json'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom'

const BlogSection = () => {

    const [companyDetails] = useContext(CompanyContext);
    const [blogSectionData, setBlogSectionData] = useState();
    let company_id_val = companyDetails && companyDetails.company_id;

    useEffect(() => {
        (async function () {
            try {
                if (company_id_val) {
                    let company_id = companyDetails.company_id
                    let template_id = companyDetails.template_id
                    const blogSection = await fetch(
                        config.apiEndpoint + '/wb-frontview/get-frontview-blog-section-data/' + company_id + '/' + template_id
                    );
                    const result = await blogSection.json();

                    setBlogSectionData({ "blog_data": result && result.hotel_blogs, "section_details": result && result.section_details });
                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, [company_id_val])

    let websitefont = '';
    let section_details = blogSectionData && blogSectionData.section_details


    return (
        <div>


            {section_details && <section>
                <div className="container container-space margin-top">
                    <div className="row">
                        <h1 className="container-heading">{section_details.section_title}</h1>
                        <p className="container-paragraph" dangerouslySetInnerHTML={{ __html: section_details.section_description }}></p>
                    </div>
                </div>
            </section>}


            {blogSectionData && blogSectionData.blog_data && blogSectionData.blog_data.length > 0 && <section className="parallax-bg" style={section_details && { backgroundImage: "url(" + config.wbImagesEndpoint + '/' + section_details.background_image + ")" }}>
                <div className="container container-space margin-top">
                    <div className="row">
                        <div className="package-slider-wrap">
                            <div id="blog-carousel" className="carousel package-carousel-slider slide" data-ride="slide" data-interval="false">
                                <div className="carousel-inner">

                                    {blogSectionData.blog_data.map(function (item, i) {
                                        var send_title = item.blog_title.replace(/[^a-zA-Z0-9 ]/g, "");
                                        send_title = send_title.replace(/ +/g, "_");
                                        send_title = send_title.toLowerCase();
                                        return (
                                            <div className={i === 0 ? "item active" : "item"} key={i}>
                                                <img src={config.wbImagesEndpoint + '/' + item.blog_image} alt={item.blog_image_alt} title={"Image showing a" + " " + item.blog_title} />
                                                <figcaption>
                                                    <div className="fig-caption-text">
                                                        <span className="fig-inner-text">{item.blog_title}</span>

                                                        <span className="package-btn-link">
                                                            <Link className="enquire-now" tabIndex="-1" to={{
                                                                pathname: config.PATH + '' + send_title
                                                            }} >
                                                                More Details
                                                        </Link>&nbsp;
                                                        </span>
                                                    </div>
                                                </figcaption>
                                            </div>
                                        )
                                    })}
                                </div>

                                <a className="left carousel-control-width carousel-control" href="#blog-carousel" data-slide="prev">
                                    <span className="icon-prev"></span>
                                </a>
                                <a className="right carousel-control-width carousel-control" href="#blog-carousel" data-slide="next">
                                    <span className="icon-next"></span>
                                </a>

                            </div>
                        </div>
                    </div>
                </div>
            </section>}

        </div>
    );
}

export default BlogSection;